import * as React from 'react';

import s from './Indicator.module.scss';

type IndicatorProps = {
  color: string;
};

const Indicator: React.FC<IndicatorProps> = ({ color }) => {
  return <div className={s.indicator} style={{ backgroundColor: color }} />;
};

export default React.memo(Indicator);
